angular.module('bizmetryApp').controller('AccountActivationController', [
  '$scope', '$http', '$location', '$timeout', 'CONFIG',
  function ($scope, $http, $location, $timeout, CONFIG) {

    console.log("⚙️ AccountActivationController loaded - ACCOUNT ACTIVATION");

    // Variable global para evitar múltiples ejecuciones
    if (window.__accountActivationInProgress) {
      console.warn("⚠️ Account activation already in progress globally - skipping");
      return;
    }

    $scope.loading = true;
    $scope.activationInProgress = false;
    $scope.message = '';
    $scope.isSuccess = false;

    const params = new URLSearchParams(window.location.search);
    const accountId = params.get('id');
    const token = params.get('token');

    // Validar que todos los parámetros requeridos estén presentes
    if (!accountId || !token) {
      $scope.loading = false;
      $scope.isSuccess = false;
      $scope.message = 'The activation link is missing required parameters or is malformed.';
      console.error("❌ Missing activation parameters");
      return;
    }

    console.log("📋 Account activation parameters:", { accountId, tokenLength: token.length });

    // Ejecutar activación inmediatamente
    activateAccountOnce();

    function activateAccountOnce() {
      // Verificar flag local
      if ($scope.activationInProgress) {
        console.warn("⏳ Activation already in progress (scope level).");
        return;
      }

      // Verificar y setear flag global
      if (window.__accountActivationInProgress) {
        console.warn("⏳ Activation already in progress (global level).");
        return;
      }

      $scope.activationInProgress = true;
      window.__accountActivationInProgress = true;
      
      console.log("🔐 Requesting temporary token for account activation...");

      // 1. Obtener token temporal
      $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/temp-auth`)
        .then(tokenResponse => {
          const tempToken = tokenResponse.data.access_token;
          console.log("✅ Temp token received");

          // 2. Activar cuenta con token temporal
          return $http.post(
            `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-account/account/${accountId}/activate?token=${token}`,
            {},
            {
              headers: { 
                'Authorization': 'Bearer ' + tempToken
              },
              responseType: 'json'
            }
          );
        })
        .then(response => {
          console.log("✅ Account activated successfully:", response.data);
          
          // Setear estado de éxito en el scope
          $scope.loading = false;
          $scope.isSuccess = true;
          $scope.message = 'Your BizMetry account has been successfully activated! You can now log in and start using the platform.';
          
          // Limpiar flag global
          window.__accountActivationInProgress = false;
        })
        .catch(error => {
          console.error("❌ Account activation failed:", error);
          
          let errorMessage = "Activation failed. The link may be invalid or expired.";
          
          // Manejar errores específicos
          if (error?.data?.message) {
            errorMessage = error.data.message;
          } else if (error?.data?.error) {
            errorMessage = error.data.error;
          }

          // Mensajes más específicos según el código de error
          if (error.status === 400) {
            if (error?.data?.message?.includes('already')) {
              errorMessage = "This account has already been activated. You can proceed to log in.";
            } else if (error?.data?.message?.includes('expired')) {
              errorMessage = "This activation link has expired. Please contact support for a new activation link.";
            } else if (error?.data?.message?.includes('Invalid')) {
              errorMessage = "Invalid activation token. Please verify the link in your email.";
            }
          } else if (error.status === 404) {
            errorMessage = "Account not found. The activation link may be invalid.";
          } else if (error.status === 401 || error.status === 403) {
            errorMessage = "Authentication failed. The activation link may be invalid or expired.";
          } else if (error.status >= 500) {
            errorMessage = "Server error occurred during activation. Please try again later or contact support.";
          }

          // Setear estado de error en el scope
          $scope.loading = false;
          $scope.isSuccess = false;
          $scope.message = errorMessage;
          
          // Limpiar flag global
          window.__accountActivationInProgress = false;
        })
        .finally(() => {
          $scope.activationInProgress = false;
          
          // Forzar actualización del scope si es necesario
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        });
    }

    // Función para ir al login
    $scope.goToLogin = function() {
      console.log("➡️ Redirecting to login...");
      window.__accountActivationInProgress = false;
      $timeout(() => {
        $location.path('/login');
      }, 100);
    };

    // Limpiar flag global cuando se destruye el controller
    $scope.$on('$destroy', function() {
      window.__accountActivationInProgress = false;
      console.log("🧹 AccountActivationController destroyed - cleaned up global flag");
    });
  }
]);